import styled from 'styled-components';

export const CellWithIcon = styled.div`
    display: flex;
    gap: 0 10.5px;
    align-items: center;
    font-weight: 'bold';
    text-decoration: 'underline';
    cursor: 'pointer';
    color: ${(props) => props.theme.orangeLink};

    div{
        display: flex;
    }

    & span[class*="material-icons"] {
        cursor: pointer;
    }
`;

export const ContainerCartaOrientacao = styled.div`
    width: 555px;
    margin: 20px 0px 0px 20px;

    & * {
        letter-spacing: 0.5px;
    }
`;
